import { Button, Input, CopySVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import CopyButton from "@/view/CopyButton";
import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import {
  ctaCopyButtonCss,
  ctaCopyContainerCss,
  ctaCopyInputCss,
} from "./CopyAssignmentLink.style";

const propTypes = {
  assignmentLink: PropTypes.string,
  contentId: PropTypes.string,
  streamProperties: PropTypes.object,
};

const CopyAssignmentLink = ({
  assignmentLink,
  contentId,
  streamProperties,
}) => {
  const { uiType } = useUserContentUIContext();
  return (
    <div css={ctaCopyContainerCss}>
      <Input
        __cssFor={ctaCopyInputCss}
        dataProps={{ "data-qa-selector": "copy-assignment-input" }}
        readonly
        isRequired={false}
        // include (read only) since some screen readers don't announce read only form elements
        label="Assignment link"
        placeholder={assignmentLink}
        value={assignmentLink}
      />
      <CopyButton
        __cssFor={ctaCopyButtonCss}
        assignmentLink={assignmentLink}
        contentId={contentId}
        buttonProps={{
          flavor: Button.flavors.primary,
          icon: {
            SvgComponent: CopySVG,
            alignment: Button.iconAlignments.left,
          },
        }}
        streamProperties={streamProperties}
        uiType={uiType}
      />
    </div>
  );
};

CopyAssignmentLink.propTypes = propTypes;

export default CopyAssignmentLink;
